import React from 'react';
import { FormattedMessage } from 'react-intl';

import {
  REQUEST_EDUCATION,
  REQUEST_EDUCATION_FAILURE,
  REQUEST_EDUCATION_SUCCESS,
} from '../constants/ActionTypes';

import { STRING, DATE } from '../constants/DataTypes';
import { fields, detailFields, entityMap } from '../constants/fields/EmployeeMasterEducation';
import convert from '../utils/dateTools';

export function mapEducation(e) {
  return {
    fields,
    detailFields,
    entityMap,
    Entity: e.Entity,
    EducationTypeName: {
      label: <div><FormattedMessage id="education.type" /></div>,
      value: e.EducationTypeName,
      type: STRING,
      entity: 'EducationType',
    },
    EducationHrSchoolName: {
      label: <div><FormattedMessage id="education.school" /></div>,
      value: e.EducationHrSchoolName,
      type: STRING,
      entity: 'EducationHrSchoolID',
    },
    EducationHrDegreeName: {
      label: <div><FormattedMessage id="education.degree" /></div>,
      value: e.EducationHrDegreeName,
      type: STRING,
      entity: 'EducationHrDegreeID',
    },
    EducationHrBranchOfStudy1Name: {
      label: <div><FormattedMessage id="education.branch1" /></div>,
      value: e.EducationHrBranchOfStudy1Name,
      type: STRING,
      entity: 'EducationHrBranchOfStudy1ID',
    },
    EducationHrBranchOfStudy2Name: {
      label: <div><FormattedMessage id="education.branch2" /></div>,
      value: e.EducationHrBranchOfStudy2Name,
      type: STRING,
      entity: 'EducationHrBranchOfStudy2ID',
    },
    EducationPeriodBegda: {
      label: <div><FormattedMessage id="education.start" /></div>,
      value: convert(e.EducationPeriodBegda),
      type: DATE,
      entity: 'EducationPeriodBegda',
    },
    EducationPeriodEnda: {
      label: <div><FormattedMessage id="education.end" /></div>,
      value: convert(e.EducationPeriodEnda),
      type: DATE,
      entity: 'EducationPeriodEnda',
    },
    EducationGrade: {
      label: <div><FormattedMessage id="education.grade" /></div>,
      value: e.EducationGrade,
      type: STRING,
      entity: 'EducationGrade',
    },
    EducationHighestText: {
      label: <div><FormattedMessage id="education.highest" /></div>,
      value: e.EducationHighestText,
      type: STRING,
      entity: 'EducationHighest',
    },
    EducationFurtherInfo: {
      label: <div><FormattedMessage id="education.info" /></div>,
      value: e.EducationFurtherInfo,
      type: STRING,
      entity: 'EducationFurtherInfo',
    },
    EducationCountryName: {
      label: <div><FormattedMessage id="education.country" /></div>,
      value: e.EducationCountryName,
      type: STRING,
    },
  };
}

export default function educationReducer(state = {}, action) {
  switch (action.type) {
    case REQUEST_EDUCATION: {
      return {
        ...state,
        ...action,
      };
    }
    case REQUEST_EDUCATION_FAILURE: {
      return {
        ...state,
        ...action,
      };
    }
    case REQUEST_EDUCATION_SUCCESS: {
      return {
        ...state,
        ...action,
        educationData: action.employeeMasterEducationList.map(mapEducation),
      };
    }
    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./src/reducers/educationReducer.js